// Floating "+X Besoin" toast (rises + fades), in world coords, counter-scaled to a ~constant
// screen size. Shared by the human player's prop interactions (GameScene.doInteraction) AND the
// agents' prop-use rendering (RemoteAgentDriver) — same look for both.
import 'phaser'

export const SFX_ACTION = 'sfx-action'

export function floatFeedback(scene: Phaser.Scene, wx: number, wy: number, text: string): void {
    const t = scene.add.text(wx, wy, text, {
        fontFamily: 'sans-serif', fontSize: '15px', fontStyle: 'bold', color: '#ffffff',
        backgroundColor: '#10151fe6', padding: { x: 7, y: 5 }, align: 'center', lineSpacing: 2,
    } as Phaser.Types.GameObjects.Text.TextStyle).setOrigin(0.5, 1).setDepth(950).setResolution(3).setStroke('#2b6cb0', 3)
    t.setScale(1 / (scene.cameras.main.zoom || 1))
    scene.tweens.add({ targets: t, y: wy - 40, alpha: 0, duration: 1500, ease: 'Cubic.easeOut', onComplete: () => t.destroy() })
}
